import { FC, useMemo } from "react";
import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import theme from "src/configs/theme";
import { grey } from "@mui/material/colors";
import { useAppDispatch, useAppSelector } from "src/app/hooks";
import { changeSidebarMenuStateAction } from "src/app/slice/sidebarSlice";
import ListItemCustomSvg from "src/components/atoms/ListItemCustomSvg";

const listItemsArray = [
  {
    href: "/",
    title: "Add Video",
    icon: (
      <path d="M16 4C16.2652 4 16.5196 4.10536 16.7071 4.29289C16.8946 4.48043 17 4.73478 17 5V9.2L22.213 5.55C22.288 5.49746 22.3759 5.4665 22.4672 5.4605C22.5586 5.4545 22.6498 5.4737 22.731 5.51599C22.8122 5.55829 22.8802 5.62206 22.9276 5.70035C22.9751 5.77865 23.0001 5.86846 23 5.96V18.04C23.0001 18.1315 22.9751 18.2214 22.9276 18.2996C22.8802 18.3779 22.8122 18.4417 22.731 18.484C22.6498 18.5263 22.5586 18.5455 22.4672 18.5395C22.3759 18.5335 22.288 18.5025 22.213 18.45L17 14.8V19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H2C1.73478 20 1.48043 19.8946 1.29289 19.7071C1.10536 19.5196 1 19.2652 1 19V5C1 4.73478 1.10536 4.48043 1.29289 4.29289C1.48043 4.10536 1.73478 4 2 4H16ZM8 8V11H5V13H7.999L8 16H10L9.999 13H13V11H10V8H8Z" />
    ),
  },
  {
    href: "/results",
    title: "Videos",
    icon: (
      <path d="M3.96966 6.21966L7.71966 2.46966C7.7893 2.40001 7.87199 2.34477 7.96298 2.30708C8.05398 2.26939 8.15151 2.25 8.25 2.25H15.75C16.1477 2.25045 16.529 2.40863 16.8102 2.68983C17.0914 2.97104 17.2496 3.35231 17.25 3.75V5.25H18.75C19.1477 5.25045 19.529 5.40863 19.8102 5.68983C20.0914 5.97104 20.2496 6.35231 20.25 6.75V20.25C20.2496 20.6477 20.0914 21.029 19.8102 21.3102C19.529 21.5914 19.1477 21.7496 18.75 21.75H8.25C7.85231 21.7496 7.47104 21.5914 7.18983 21.3102C6.90863 21.029 6.75045 20.6477 6.75 20.25V18.75H5.25C4.85231 18.7496 4.47104 18.5914 4.18983 18.3102C3.90863 18.029 3.75045 17.6477 3.75 17.25V6.75C3.75 6.65151 3.76939 6.55398 3.80708 6.46298C3.84477 6.37198 3.90001 6.2893 3.96966 6.21966ZM11.25 18H15.75C15.9489 18 16.1397 17.921 16.2803 17.7803C16.421 17.6397 16.5 17.4489 16.5 17.25C16.5 17.0511 16.421 16.8603 16.2803 16.7197C16.1397 16.579 15.9489 16.5 15.75 16.5H11.25C11.0511 16.5 10.8603 16.579 10.7197 16.7197C10.579 16.8603 10.5 17.0511 10.5 17.25C10.5 17.4489 10.579 17.6397 10.7197 17.7803C10.8603 17.921 11.0511 18 11.25 18ZM11.25 15H15.75C15.9489 15 16.1397 14.921 16.2803 14.7803C16.421 14.6397 16.5 14.4489 16.5 14.25C16.5 14.0511 16.421 13.8603 16.2803 13.7197C16.1397 13.579 15.9489 13.5 15.75 13.5H11.25C11.0511 13.5 10.8603 13.579 10.7197 13.7197C10.579 13.8603 10.5 14.0511 10.5 14.25C10.5 14.4489 10.579 14.6397 10.7197 14.7803C10.8603 14.921 11.0511 15 11.25 15ZM5.25 17.25H6.75V9.75C6.75 9.65151 6.76939 9.55398 6.80708 9.46298C6.84477 9.37198 6.90001 9.2893 6.96966 9.21966L10.7197 5.46966C10.7893 5.40001 10.872 5.34477 10.963 5.30708C11.054 5.26939 11.1515 5.25 11.25 5.25H15.75V3.75H8.56059L5.25 7.06069V17.25Z" />
    ),
  },
  {
    href: "/angleThresholds",
    title: "Angle Thresholds",
    icon: (
      <path d="M12.0117 9.15474C11.3109 9.15474 10.6547 9.42661 10.1578 9.92349C9.66329 10.4204 9.38907 11.0766 9.38907 11.7774C9.38907 12.4782 9.66329 13.1344 10.1578 13.6313C10.6547 14.1258 11.3109 14.4001 12.0117 14.4001C12.7125 14.4001 13.3688 14.1258 13.8656 13.6313C14.3602 13.1344 14.6344 12.4782 14.6344 11.7774C14.6344 11.0766 14.3602 10.4204 13.8656 9.92349C13.6229 9.67893 13.3341 9.48504 13.0158 9.35307C12.6976 9.2211 12.3563 9.15368 12.0117 9.15474ZM21.675 14.6743L20.1422 13.3641C20.2149 12.9188 20.2524 12.4641 20.2524 12.0118C20.2524 11.5594 20.2149 11.1024 20.1422 10.6594L21.675 9.34927C21.7908 9.25014 21.8737 9.11812 21.9126 8.97075C21.9515 8.82338 21.9447 8.66765 21.893 8.52427L21.8719 8.46333C21.45 7.2837 20.818 6.19026 20.0063 5.23599L19.9641 5.18677C19.8655 5.07087 19.7341 4.98756 19.5873 4.94782C19.4404 4.90807 19.285 4.91375 19.1414 4.96411L17.2383 5.64146C16.5352 5.06489 15.7524 4.61021 14.9039 4.2938L14.5359 2.30396C14.5082 2.15405 14.4355 2.01615 14.3275 1.90856C14.2195 1.80097 14.0813 1.72879 13.9313 1.70161L13.868 1.68989C12.6492 1.46958 11.3649 1.46958 10.1461 1.68989L10.0828 1.70161C9.93281 1.72879 9.79462 1.80097 9.68662 1.90856C9.57861 2.01615 9.50589 2.15405 9.47813 2.30396L9.10782 4.30317C8.26742 4.6221 7.48452 5.07569 6.78985 5.64614L4.87266 4.96411C4.72914 4.91335 4.57358 4.90746 4.42663 4.94724C4.27969 4.98701 4.14833 5.07055 4.05 5.18677L4.00782 5.23599C3.19756 6.19128 2.56564 7.28444 2.14219 8.46333L2.1211 8.52427C2.01563 8.81724 2.10235 9.14536 2.33907 9.34927L3.89063 10.6735C3.81797 11.1141 3.78282 11.5641 3.78282 12.0094C3.78282 12.4594 3.81797 12.9094 3.89063 13.3454L2.34375 14.6696C2.22796 14.7687 2.14509 14.9007 2.10615 15.0481C2.06722 15.1955 2.07407 15.3512 2.12578 15.4946L2.14688 15.5555C2.5711 16.7344 3.19688 17.8243 4.0125 18.7829L4.05469 18.8321C4.15326 18.948 4.28462 19.0313 4.43148 19.071C4.57833 19.1108 4.73379 19.1051 4.87735 19.0547L6.79454 18.3727C7.49297 18.9469 8.2711 19.4016 9.11251 19.7157L9.48282 21.7149C9.51058 21.8648 9.5833 22.0027 9.6913 22.1103C9.79931 22.2179 9.9375 22.2901 10.0875 22.3172L10.1508 22.329C11.3815 22.5505 12.6419 22.5505 13.8727 22.329L13.9359 22.3172C14.086 22.2901 14.2241 22.2179 14.3321 22.1103C14.4402 22.0027 14.5129 21.8648 14.5406 21.7149L14.9086 19.725C15.757 19.4063 16.5399 18.954 17.243 18.3774L19.1461 19.0547C19.2896 19.1055 19.4452 19.1114 19.5921 19.0716C19.7391 19.0318 19.8704 18.9483 19.9688 18.8321L20.0109 18.7829C20.8266 17.8196 21.4524 16.7344 21.8766 15.5555L21.8977 15.4946C21.9984 15.204 21.9117 14.8782 21.675 14.6743ZM12.0117 15.8977C9.73594 15.8977 7.89141 14.0532 7.89141 11.7774C7.89141 9.50161 9.73594 7.65708 12.0117 7.65708C14.2875 7.65708 16.132 9.50161 16.132 11.7774C16.132 14.0532 14.2875 15.8977 12.0117 15.8977Z" />
    ),
  },
  {
    href: "/profile",
    title: "Profile",
    icon: (
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
    ),
  },
];

const adminListItemsArray = [
  {
    href: "/users",
    title: "Users",
    icon: (
      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
    ),
  },
  {
    href: "/companies",
    title: "Companies",
    icon: (
      <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
    ),
  },
  {
    href: "/allTasks",
    title: "All Videos",
    icon: (
      <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
    ),
  },
];

export const ListItems: FC = () => {
  const { pathname } = useLocation(),
    dispatch = useAppDispatch(),
    auth = useAppSelector((state) => state.auth);

  const isAdmin = useMemo(() => {
    return auth?.isAdmin;
  }, [auth?.isAdmin]);

  const listItem = ({ href, title, icon, index }: any) => {
    const isSelected = href === pathname;
    return (
      <ListItem disablePadding key={index} sx={{ py: 0.5, px: 2 }}>
        <ListItemButton
          sx={{
            backgroundColor: isSelected
              ? theme.palette.primary.main
              : undefined,
            borderRadius: "50px",
            "&:hover": {
              backgroundColor: isSelected
                ? theme.palette.primary.main
                : undefined,
            },
          }}
          onClick={() => dispatch(changeSidebarMenuStateAction(false))}
          component={RouterLink}
          to={href}
        >
          <ListItemIcon>
            <ListItemCustomSvg svgPath={icon} selected={isSelected} />
          </ListItemIcon>
          <ListItemText
            primary={title}
            primaryTypographyProps={{
              color: isSelected ? "white" : grey[600],
              fontWeight: isSelected ? "bold !important" : "normal",
            }}
          />
        </ListItemButton>
      </ListItem>
    );
  };

  return (
    <List>
      {listItemsArray.map(({ href, title, icon }, index) =>
        listItem({ href, title, icon, index }),
      )}
      {isAdmin && (
        <>
          <Divider sx={{ color: grey[500], my: 2 }}>Adminstration</Divider>
          {adminListItemsArray.map(({ href, title, icon }, index) =>
            listItem({ href, title, icon, index }),
          )}
        </>
      )}
    </List>
  );
};

export default ListItems;
